import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";

interface Props {
	durationMs: number;
	isPlaying: boolean;
	progress?: number;
}

const TimerBam = ({ durationMs, isPlaying, progress = 0 }: Props) => {
	const initialTimeLeft = Math.max(durationMs * (1 - progress / 100), 0);
	const [timeLeft, setTimeLeft] = useState(initialTimeLeft);
	const intervalRef = useRef<NodeJS.Timeout | undefined>(undefined);

	useEffect(() => {
		if (!isPlaying || timeLeft <= 0) {
			clearInterval(intervalRef.current);
			return;
		}

		intervalRef.current = setInterval(() => {
			setTimeLeft((prev) => {
				const next = prev - 1000;
				return next >= 0 ? next : 0;
			});
		}, 1000);

		return () => clearInterval(intervalRef.current);
	}, [isPlaying, timeLeft]);

	const formatted = dayjs.duration(timeLeft).format("mm:ss");

	return (
		<div
			style={{
				fontFamily: "RailwayGank",
				fontSize: "100px",
				color: "#E32084",
				textTransform: "uppercase",
			}}
		>
			{formatted}
		</div>
	);
};

export default TimerBam;
